import * as i1 from '@angular/common';
import { isPlatformBrowser, DecimalPipe, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, PLATFORM_ID, Component, ChangeDetectionStrategy, Inject, Input, Output, Pipe, Directive, HostBinding, NgModule } from '@angular/core';
import * as i2 from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1$1 from '@ngx-translate/core';
import { TranslatePipe, TranslateModule } from '@ngx-translate/core';
import * as i2$1 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';

var LabelFormat;
(function (LabelFormat) {
    LabelFormat[LabelFormat["NONE"] = 0] = "NONE";
    LabelFormat[LabelFormat["LANGUAGE"] = 1] = "LANGUAGE";
    LabelFormat[LabelFormat["LOCATION"] = 2] = "LOCATION";
    LabelFormat[LabelFormat["LANGUAGE_PLUS_CURRENCY"] = 3] = "LANGUAGE_PLUS_CURRENCY";
    LabelFormat[LabelFormat["LOCATION_PLUS_CURRENCY"] = 4] = "LOCATION_PLUS_CURRENCY";
})(LabelFormat || (LabelFormat = {}));
class GptLocationSwitcherComponent {
    constructor(platformId) {
        this.platformId = platformId;
        this.selectedItemFormat = LabelFormat.LANGUAGE_PLUS_CURRENCY;
        this.dropdownItemFormat = LabelFormat.LANGUAGE_PLUS_CURRENCY;
        this.hideSelectedLanguageFlag = false;
        this.locationChange = new EventEmitter();
        this.isMenuOpen = false;
        if (isPlatformBrowser(this.platformId)) {
            this.isMobile = window.screen.width < 768;
        }
    }
    onLocationChange(location) {
        this.locationChange.emit(location);
    }
    onToggle(e) {
        this.isMenuOpen = e;
    }
    getLabel(location, format) {
        switch (format) {
            case LabelFormat.NONE:
                return '';
            case LabelFormat.LANGUAGE:
                return location.lang.name;
            case LabelFormat.LOCATION:
                return location.name || '';
            case LabelFormat.LANGUAGE_PLUS_CURRENCY:
                return `${location.lang.name} / ${location.currency}`;
            case LabelFormat.LOCATION_PLUS_CURRENCY:
                return `${location.name || ''} / ${location.currency}`;
            default:
                return location.lang.name;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocationSwitcherComponent, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.3", type: GptLocationSwitcherComponent, selector: "gpt-location-switcher", inputs: { locations: "locations", selectedLocation: "selectedLocation", selectedItemFormat: "selectedItemFormat", dropdownItemFormat: "dropdownItemFormat", hideSelectedLanguageFlag: "hideSelectedLanguageFlag" }, outputs: { locationChange: "locationChange" }, ngImport: i0, template: "<div\n  ngbDropdown\n  [placement]=\"\n    isMobile ? 'bottom top' : 'bottom-left top-left bottom-right top-right'\n  \"\n  (openChange)=\"onToggle($event)\"\n  class=\"d-inline-block w-100\"\n  *ngIf=\"locations\"\n>\n  <!-- toggle -->\n  <button\n    class=\"btn btn-sm btn-text p-0 border-0 shadow-none gpl-lg-16 gpy-4\"\n    ngbDropdownToggle\n  >\n    <p class=\"p4-regular d-flex align-items-center mb-0\">\n      <i\n        *ngIf=\"!hideSelectedLanguageFlag\"\n        class=\"flag-icon flag-small flag-selected rounded-circle\"\n        [ngClass]=\"\n          'svg-' + (selectedLocation.customFlag || selectedLocation.code) + '-flag-sm'\n        \"\n      ></i>\n      <span class=\"gml-8\">\n        {{ getLabel(selectedLocation, selectedItemFormat) }}\n      </span>\n      <i\n        class=\"gpicon-down gpicon-lg text-gray\"\n        [class.active]=\"isMenuOpen\"\n      ></i>\n    </p>\n  </button>\n\n  <!-- menu -->\n  <div ngbDropdownMenu class=\"border-0 shadow gmt-24 gpb-0 gpb-md-8\">\n    <button\n      ngbDropdownItem\n      *ngFor=\"let location of locations\"\n      (click)=\"onLocationChange(location)\"\n      class=\"p3-regular location-dropdown-item text-secondary d-flex align-items-center gpy-4 gpy-md-8 gmb-8 gmb-md-0\"\n    >\n      <i\n        class=\"flag-icon rounded-circle gmr-8 gmr-lg-16\"\n        [class.flag-small]=\"isMobile\"\n        [ngClass]=\"'svg-' + (location.customFlag || location.code) + '-flag' + (isMobile ? '-sm': '')\"\n      ></i>\n\n      {{ getLabel(location, dropdownItemFormat) }}\n    </button>\n  </div>\n</div>\n", styles: ["i{transition:transform .2s}i.active{transform:rotate(180deg)}.flag-icon{width:32px;height:32px;box-shadow:0 0 0 1px #efeff4}.flag-icon.flag-small{width:24px;height:24px}.dropdown-menu{border-radius:.75rem;min-width:11.125rem;max-width:100%}@media (min-width: 576px){.dropdown-menu{min-width:17.25rem}}.location-dropdown-item,.location-dropdown-item:focus{border:none;box-shadow:none;outline:none;background-color:unset;color:unset}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "popperOptions", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { kind: "directive", type: i2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { kind: "directive", type: i2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { kind: "directive", type: i2.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocationSwitcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'gpt-location-switcher', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  ngbDropdown\n  [placement]=\"\n    isMobile ? 'bottom top' : 'bottom-left top-left bottom-right top-right'\n  \"\n  (openChange)=\"onToggle($event)\"\n  class=\"d-inline-block w-100\"\n  *ngIf=\"locations\"\n>\n  <!-- toggle -->\n  <button\n    class=\"btn btn-sm btn-text p-0 border-0 shadow-none gpl-lg-16 gpy-4\"\n    ngbDropdownToggle\n  >\n    <p class=\"p4-regular d-flex align-items-center mb-0\">\n      <i\n        *ngIf=\"!hideSelectedLanguageFlag\"\n        class=\"flag-icon flag-small flag-selected rounded-circle\"\n        [ngClass]=\"\n          'svg-' + (selectedLocation.customFlag || selectedLocation.code) + '-flag-sm'\n        \"\n      ></i>\n      <span class=\"gml-8\">\n        {{ getLabel(selectedLocation, selectedItemFormat) }}\n      </span>\n      <i\n        class=\"gpicon-down gpicon-lg text-gray\"\n        [class.active]=\"isMenuOpen\"\n      ></i>\n    </p>\n  </button>\n\n  <!-- menu -->\n  <div ngbDropdownMenu class=\"border-0 shadow gmt-24 gpb-0 gpb-md-8\">\n    <button\n      ngbDropdownItem\n      *ngFor=\"let location of locations\"\n      (click)=\"onLocationChange(location)\"\n      class=\"p3-regular location-dropdown-item text-secondary d-flex align-items-center gpy-4 gpy-md-8 gmb-8 gmb-md-0\"\n    >\n      <i\n        class=\"flag-icon rounded-circle gmr-8 gmr-lg-16\"\n        [class.flag-small]=\"isMobile\"\n        [ngClass]=\"'svg-' + (location.customFlag || location.code) + '-flag' + (isMobile ? '-sm': '')\"\n      ></i>\n\n      {{ getLabel(location, dropdownItemFormat) }}\n    </button>\n  </div>\n</div>\n", styles: ["i{transition:transform .2s}i.active{transform:rotate(180deg)}.flag-icon{width:32px;height:32px;box-shadow:0 0 0 1px #efeff4}.flag-icon.flag-small{width:24px;height:24px}.dropdown-menu{border-radius:.75rem;min-width:11.125rem;max-width:100%}@media (min-width: 576px){.dropdown-menu{min-width:17.25rem}}.location-dropdown-item,.location-dropdown-item:focus{border:none;box-shadow:none;outline:none;background-color:unset;color:unset}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.PlatformRef, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { locations: [{
                type: Input
            }], selectedLocation: [{
                type: Input
            }], selectedItemFormat: [{
                type: Input
            }], dropdownItemFormat: [{
                type: Input
            }], hideSelectedLanguageFlag: [{
                type: Input
            }], locationChange: [{
                type: Output
            }] } });

class GptLocalStringNumberPipe {
    constructor(translate) {
        this.translate = translate;
        this.regex = /(\d+(,\d{3})*(\.\d+)?)/g;
    }
    transform(value, digitsInfo) {
        if (typeof value === 'number') {
            value = String(value);
        }
        if (!value || typeof value !== 'string') {
            return value;
        }
        if (value.match(this.regex)) {
            const decimalPipe = new DecimalPipe(this.translate.currentLang);
            return value.replace(this.regex, (num) => decimalPipe.transform(num.replace(/,/g, ''), digitsInfo));
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocalStringNumberPipe, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.1.3", ngImport: i0, type: GptLocalStringNumberPipe, name: "localStringNumber" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocalStringNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'localStringNumber',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; } });

class GptLocalNumberPipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(value, digitsInfo) {
        if (typeof value !== 'number') {
            return value;
        }
        const decimalPipe = new DecimalPipe(this.translate.currentLang);
        return decimalPipe.transform(value, digitsInfo);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocalNumberPipe, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.1.3", ngImport: i0, type: GptLocalNumberPipe, name: "localNumber" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocalNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'localNumber',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; } });

/**
 * Use translation by key, but make sure to return array.
 */
class TranslateArrayPipe extends TranslatePipe {
    transform(query, ...args) {
        const value = super.transform(query, ...args);
        if (!Array.isArray(value)) {
            return [];
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: TranslateArrayPipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.1.3", ngImport: i0, type: TranslateArrayPipe, name: "translateArray", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: TranslateArrayPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'translateArray', pure: false }]
        }] });

class GptExternalLinkDirective {
    constructor(translate, router) {
        this.translate = translate;
        this.router = router;
    }
    ngOnInit() {
        this.subscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd), startWith({ url: this.router.url }))
            .subscribe(() => {
            this.href = this.dataHref?.includes('{lang}')
                ? this.dataHref.replace('{lang}', this.translate.currentLang)
                : this.dataHref;
        });
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptExternalLinkDirective, deps: [{ token: i1$1.TranslateService }, { token: i2$1.Router }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.3", type: GptExternalLinkDirective, selector: "a[gptExternalLink]", inputs: { dataHref: "dataHref" }, host: { properties: { "href": "this.href" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptExternalLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a[gptExternalLink]',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: i2$1.Router }]; }, propDecorators: { dataHref: [{
                type: Input
            }], href: [{
                type: HostBinding,
                args: ['href']
            }] } });

const pipes = [GptLocalStringNumberPipe, GptLocalNumberPipe, TranslateArrayPipe];
const directives = [GptExternalLinkDirective];
class GptLocalizationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocalizationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.3", ngImport: i0, type: GptLocalizationModule, declarations: [GptLocationSwitcherComponent, GptLocalStringNumberPipe, GptLocalNumberPipe, TranslateArrayPipe, GptExternalLinkDirective], imports: [CommonModule, NgbDropdownModule, i1$1.TranslateModule], exports: [GptLocationSwitcherComponent, GptLocalStringNumberPipe, GptLocalNumberPipe, TranslateArrayPipe, GptExternalLinkDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocalizationModule, imports: [CommonModule, NgbDropdownModule, TranslateModule.forChild()] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptLocalizationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [GptLocationSwitcherComponent, ...pipes, ...directives],
                    imports: [CommonModule, NgbDropdownModule, TranslateModule.forChild()],
                    exports: [GptLocationSwitcherComponent, ...pipes, ...directives],
                }]
        }] });

var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["GBP"] = "GBP";
    Currency["PLN"] = "PLN";
    Currency["CHF"] = "CHF";
})(Currency || (Currency = {}));
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["EN"] = "en";
    LanguageCode["SL"] = "sl";
    LanguageCode["PL"] = "pl";
    LanguageCode["SK"] = "sk";
    LanguageCode["IT"] = "it";
    LanguageCode["MX"] = "mx";
    LanguageCode["AL"] = "sq-AL";
    LanguageCode["TH"] = "th";
})(LanguageCode || (LanguageCode = {}));
var LocationCode;
(function (LocationCode) {
    LocationCode["CH"] = "ch";
    LocationCode["EU"] = "eu";
    LocationCode["PL"] = "pl";
    LocationCode["US"] = "us";
    LocationCode["UK"] = "uk";
    LocationCode["SL"] = "sl";
    LocationCode["SK"] = "sk";
    LocationCode["IT"] = "it";
    LocationCode["MX"] = "mx";
    LocationCode["AL"] = "al";
    LocationCode["TH"] = "th";
})(LocationCode || (LocationCode = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { Currency, GptExternalLinkDirective, GptLocalNumberPipe, GptLocalStringNumberPipe, GptLocalizationModule, GptLocationSwitcherComponent, LabelFormat, LanguageCode, LocationCode, TranslateArrayPipe };
